export { default } from './TextWithIcon'
